













import { IBasketProviderData } from "@/models/providers/baskets";
import { ICheckoutProviderData } from "@/models/providers/checkout";
import { Vue, Component, Inject } from "vue-property-decorator";

@Component
export default class CheckoutButton extends Vue {
  // Inject

  @Inject({ from: "basketProviderData" })
  public readonly $basketProviderData!: () => IBasketProviderData;

  @Inject({ from: "checkoutProviderData" })
  public readonly $checkoutProviderData!: () => ICheckoutProviderData;

  // Computed

  public get $basketData() {
    return this.$basketProviderData();
  }

  public get $checkoutData() {
    return this.$checkoutProviderData();
  }

  public get isDisabled() {
    if (this.$checkoutData.isProcessing) return false;
    if (this.$basketData.isProcessing) return true;
    if (this.$basketData.isEmptyBasket) return true;
    if (!this.$checkoutData.canCheckout) return true;
    return false;
  }

  public get isProcessing() {
    if (this.$checkoutData.isProcessing) return true;
    return false;
  }
}
